module.exports = __webpack_public_path__ + "img/CorporateFareOutlined.c2e89666.svg";